// helpers.
const status = ['Detenido', 'Funcionamiento']

// main function.
const instalationStatusFormat = (num) => {
  return status[num]
}

export default instalationStatusFormat
